/** 访问页面统计详情 echarts */
import React from 'react';
import ReactEcharts from '../../../components/Echarts/ReactEcharts';

class HomeEcharts extends React.Component{
  timeIdx;
  // 重新绘制
  UNSAFE_componentWillReceiveProps = () => {
    clearTimeout(this.timeIdx);
    this.timeIdx = setTimeout(() => {
      if (this.refs.echartsSecond) {
        this.refs.echartsSecond.updateEcharts();
      }
    }, 60);
  };
  // 绘图
  getOption() {
    const {dayList} = this.props;
    let dnsTime = [];
    let domAnalysisTime = [];
    let domCompleteTime = [];
    let firstPaintTime = [];
    let loadTime = [];
    let requestTime = [];
    let tcpTime = [];
    let timeSlot = [];
    dayList.forEach(item => {
      dnsTime.push(item.dnsTime);
      domAnalysisTime.push(item.domAnalysisTime);
      domCompleteTime.push(item.domCompleteTime);
      firstPaintTime.push(item.firstPaintTime);
      loadTime.push(item.loadTime);
      requestTime.push(item.requestTime);
      tcpTime.push(item.tcpTime);
      timeSlot.push(item.timeSlot);
    });
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['dnsTime', 'domAnalysisTime', 'domCompleteTime', 'firstPaintTime', 'loadTime', 'requestTime', 'tcpTime'],
        bottom: 10
      },
      grid: {
        left: '15',
        right: '15',
        top: '30',
        bottom: '40',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          axisLabel: {
            rotate: -45
          },
          data: timeSlot
        }
      ],
      yAxis: [
        {
          type: 'value',
          scale: true,
          name: '',
          min: 0,
          boundaryGap: [0.2, 0.2]
        }
      ],
      series: [
        {
          name: 'dnsTime',
          type: 'line',
          data: dnsTime
        }, {
          name: 'domAnalysisTime',
          type: 'line',
          data: domAnalysisTime
        }, {
          name: 'domCompleteTime',
          type: 'line',
          data: domCompleteTime
        }, {
          name: 'firstPaintTime',
          type: 'line',
          data: firstPaintTime
        }, {
          name: 'loadTime',
          type: 'line',
          data: loadTime
        }, {
          name: 'requestTime',
          type: 'line',
          data: requestTime
        }, {
          name: 'tcpTime',
          type: 'line',
          data: tcpTime
        }
      ]
    };
    return option;
  };
  render() {
    const {dayList} = this.props;
    return (
      <ReactEcharts ref="echartsSecond" key='echartsSecond' option={this.getOption()} isHide={dayList.length === 0} h={300}></ReactEcharts>
    );
  }
};
export default HomeEcharts;
